import { render, staticRenderFns } from "./girl.vue?vue&type=template&id=1923309d&"
import script from "./girl.vue?vue&type=script&lang=js&"
export * from "./girl.vue?vue&type=script&lang=js&"
import style0 from "./girl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports